module.exports = __webpack_public_path__ + "media/images/river_and_mountain-59ac0cff.jpg";